<template>
  <div :class="$style.container" :style="{ backgroundImage: data.image ? `url(${data.image})` : '' }">
    <BigScrollbar ref="scroll" :containerHeight="containerHeight" />
    <div :class="$style.content" ref="content">
      <section :class="$style.row" v-for="(block, index) in data.blocks" :key="index">
        <component :is="block.type" :settings="block.settings" :content="block.content"></component>
      </section>
      <Arrows
        v-show="currentInSlider"
        :bottom="true"
        :class="$style.arrow"
      />
      <FooterComponent />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IntroBlock from '@/components/IntroBlock'
import BigScrollbar from '@/components/BigScrollbar'
import FigureBlock from '@/components/FigureBlock'
import IconsBlock from '@/components/IconsBlock'
import Covers from '@/components/Covers'
import RotatingDeed from '@/components/RotatingDeed'
import TechIntro from '@/components/TechIntro'
import ContactIntro from '@/components/ContactIntro'
import LogosBlock from '@/components/LogosBlock'
import JobList from '@/components/JobList'
import Team from '@/components/Team'
import VideoBlock from '@/components/VideoBlock'
import ContactForm from '@/components/ContactForm'
import InfoBlock from '@/components/InfoBlock'
import InfoBlockHalf from '@/components/InfoBlockHalf'
import HoverSlideshow from '@/components/HoverSlideshow'
import ParagraphBlock from '@/components/ParagraphBlock'
import TechSpecifications from '@/components/TechSpecifications'
import FooterComponent from '@/components/FooterComponent'
import Arrows from '@/components/Arrows'

export default {
  props: ['data'],
  components: {
    FigureBlock,
    IntroBlock,
    BigScrollbar,
    Team,
    LogosBlock,
    JobList,
    TechIntro,
    ContactIntro,
    RotatingDeed,
    IconsBlock,
    Covers,
    TechSpecifications,
    ParagraphBlock,
    InfoBlock,
    InfoBlockHalf,
    ContactForm,
    VideoBlock,
    HoverSlideshow,
    FooterComponent,
    Arrows
  },

  data() {
    return {
      containerHeight: 0
    }
  },

  computed: {
    ...mapGetters(['currentInSlider'])
  },

  mounted() {
    this.containerHeight = this.$refs.content.clientHeight
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  position: relative;
  display: flex;
  background-position: 100% 0;
  background-size: 50% auto;
  background-repeat: no-repeat;

  .arrow {
    display: flex;

    @include mq(md) {
      display: none;
    }
  }
}

.content {
  width: 100%;
  flex: 0 0 auto;
  overflow: hidden;

  @include mq(md) {
    width: calc(100% - 114px);
  }

  @include mq(ds) {
    width: calc(100% - 190px);
  }
}

.row {
  margin: auto;
  margin-top: $viewport-margin-mobile;
  // max-width: 1280px;

  @include mq(sm) {
    margin: auto;
    margin-top: 120px;
  }

  @include mq(md) {
    margin: auto;
    margin-top: $viewport-margin;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PageContent.vue